<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <span class="headline font-weight-medium"
            >{{ nombre_mes.toUpperCase() }}, {{ anio }}</span
          >
        </v-col>
        <v-col cols="8" class="pt-1" v-if="cerrado === true">
          <v-btn
            dark
            color="success"
            width="140"
            class="float-right"
            :loading="is_download"
            @click="descargaReporte()"
            v-if="this.$hasPermision('recibos-honorarios.download')"
          >
            Descargar XLS
          </v-btn>
          <v-btn
            v-if="this.$hasPermision('recibos-honorarios.cierra')"
            color="success"
            width="140"
            class="float-right"
            @click="calcularCerrarBtn"
            style="margin-right: 2%"
          >
            Calcular y Cerrar
          </v-btn>
          <!--<v-btn color="primary" width="140" class="float-right"  style="margin-right: 2%">
                        Guardar
                    </v-btn>-->
          <v-btn
            v-if="this.$hasPermision('planillas.actualiza')"
            color="dark"
            width="140"
            class="float-right"
            @click="actualizarBtn"
            style="margin-right: 2%"
          >
            Actualizar
          </v-btn>
        </v-col>
        <v-col cols="8" class="pt-1" v-else>
          <v-btn
            dark
            color="success"
            width="140"
            class="float-right"
            :loading="is_download"
            @click="descargaReporte()"
          >
            Descargar XLS
          </v-btn>
          <v-btn
            v-if="this.$hasPermision('recibos-honorarios.abre')"
            width="160"
            class="float-right"
            style="margin-right: 2%"
            @click="reabrirHonorarioBtn()"
          >
            Reabrir Honorarios
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Recibos por Honorarios
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="itemsAux"
              :search="search"
              height="57vh"
            >
              <template v-slot:item.totalDescuento="{ item }">
                <span
                  @click="modalDescuentos(item)"
                  v-if="item.estado == true"
                  style="cursor:pointer"
                  >{{ item.totalDescuento }}</span
                >
                <span v-else>{{ item.totalDescuento }}</span>
              </template>
              <template v-slot:item.totalBonos="{ item }">
                <span
                  @click="modalBonos(item)"
                  v-if="item.estado == true"
                  style="cursor:pointer"
                  >{{ item.totalBonos }}</span
                >
                <span v-else>{{ item.totalBonos }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <crear-descuento ref="CrearDescuento"></crear-descuento>
    <crear-bonos ref="CrearBonos"></crear-bonos>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../components/auth/OfficeLogin";
import ArrayTools from "../../helpers/ArrayTools";
import router from "@/router/index";
import CrearDescuento from "../../components/honorarios/CrearDescuento";
import CrearBonos from "../../components/honorarios/CrearBonos";

export default {
  name: "honorarios",
  components: {
    OfficeLogin,
    CrearDescuento,
    CrearBonos,
  },
  data() {
    return {
      cerrado: false,
      anio: null,
      nombre_mes: null,
      headers: [
        { text: "APELLIDO", value: "apellidos_empleado" },
        { text: "NOMBRES", value: "nombres_empleado" },
        { text: "CENTRO DE COSTOS", value: "centro_costos" },
        { text: "PUESTO", value: "puesto" },
        { text: "MODALIDAD", value: "modalidad" },
        { text: "SUELDO", value: "sueldo" },
        { text: "DESCUENTO", value: "totalDescuento", align: "center" },
        { text: "BONOS", value: "totalBonos", align: "center" },
        { text: "TOTAL A PAGAR", value: "total_pagar" },
      ],
      search: null,
      itemsBreadcrumbs: [
        {
          text: "Recibo por Honorarios",
          disabled: true,
          href: "",
        },
      ],
      itemsAux: [],
      total: 0.0,
      is_download: false,
      idRecibo: null,
    };
  },
  computed: {
    ...mapState("honorarioDetalle", ["itemsHonorarios", "file_horarioDetalle"]),
  },
  methods: {
    ...mapActions("honorarioDetalle", [
      "getItemsEmple",
      "calculaCierra",
      "reabrirHonorario",
      "reciboDownload",
      "actualizarReciboHonorario",
    ]),
    ...mapActions("honorarios", ["getHonorarios"]),
    async descargaReporte() {
      this.is_download = true;
      // let nameReporte = 'recibo-honorarios-'+this.nombre_mes+'-'+this.anio+'.xlsx';
      // console.log(nameReporte)//this.emptyFileSales();
      //let filters_data = Object.assign({}, this.filters);
      //filters_data.company_id = this.company_id;
      await this.reciboDownload(this.idRecibo);
      this.is_download = false;
      if (this.file_horarioDetalle) {
        let url =
          process.env.VUE_APP_API_URL_BASE + "/" + this.file_horarioDetalle;
        window.open(url);
      }
    },
    modalDescuentos(item) {
      // console.log(item);
      this.$refs.CrearDescuento.showForm("Descuentos", item, this.total);
      //this.totalPlanilla();
    },
    modalBonos(item) {
      this.$refs.CrearBonos.showForm("Bonos", item, this.total);
      //this.totalPlanilla();
    },
    async actualizarBtn() {
      // this.id_planilla = parseInt(localStorage.getItem('id_planilla'));
      this.idRecibo = localStorage.getItem("id_recibo");
      await this.actualizarReciboHonorario(this.idRecibo);
      this.itemsAux = this.itemsHonorarios;
    },
    async getAll() {
      this.idRecibo = localStorage.getItem("id_recibo");
      this.nombre_mes = localStorage.getItem("nombre_mes_honorario");
      this.anio = localStorage.getItem("anio_honorario");
      await this.getItemsEmple(this.idRecibo);
      this.itemsAux = this.itemsHonorarios;
      if (this.itemsAux.length > 0) {
        this.cerrado = this.itemsAux[0].estado;
      }
    },
    async calcularCerrarBtn() {
      this.calculaCierra(this.itemsAux);
      await this.getHonorarios();
      router.push("/app/planillas/honorarios");
    },
    async reabrirHonorarioBtn() {
      await this.reabrirHonorario(this.itemsAux);
      await this.getHonorarios();
      router.push("/app/planillas/honorarios");
    },
  },
  created() {
    this.getAll();
  },
};
</script>

<style scoped></style>
